import { render } from "./GalleryBox.vue?vue&type=template&id=6343a622&scoped=true"
import script from "./GalleryBox.vue?vue&type=script&lang=js"
export * from "./GalleryBox.vue?vue&type=script&lang=js"

import "./GalleryBox.vue?vue&type=style&index=0&id=6343a622&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6343a622"

export default script